/* je-mobile-ux-20260905: one responsive category section, and background-only animation discovery. */
(() => {
  'use strict';
  const mobile = matchMedia('(max-width:900px)');
  function categories(scope = document) {
    const showroom = scope.querySelector('#categories');
    const disclosure = scope.querySelector('#je-mobile-categories');
    if (!showroom || !disclosure || disclosure.dataset.ready) return;
    const original = document.createComment('Original desktop category position');
    showroom.before(original);
    disclosure.dataset.ready = 'true';
    function place() {
      if (mobile.matches) disclosure.append(showroom);
      else original.after(showroom);
    }
    function revealHash() {
      if (mobile.matches && location.hash === '#categories') {
        disclosure.open = true;
        requestAnimationFrame(() => showroom.scrollIntoView({block:'start',behavior:'instant'}));
      }
    }
    place(); revealHash();
    mobile.addEventListener('change', place);
    window.addEventListener('hashchange', revealHash);
    disclosure.addEventListener('toggle', () => {
      // Existing page effects cache section positions; a disclosure changes them.
      window.dispatchEvent(new Event('resize'));
    });
  }
  function animationScheduler() {
    if (!('IntersectionObserver' in window) || !Element.prototype.getAnimations) return;
    const seen = new WeakMap(), tracked = new Set(), pending = new Set(), pointers = new Set();
    let timer = 0, busyUntil = 0;
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    function sync(element, visible) {
      // CSS can remove an animation while its target remains connected. A saved
      // cancelled object must never be played back into existence on re-entry.
      const associated = element.getAnimations({subtree:true});
      const current = (seen.get(element) || []).filter(animation => associated.includes(animation) && animation.effect?.getTiming().iterations === Infinity);
      seen.set(element, current);
      for (const animation of current) {
        try {
          if (!visible || document.hidden || reduced.matches) {
            if (animation.playState === 'running') { animation.__jeOff = true; animation.pause(); }
          } else if (animation.__jeOff) { animation.__jeOff = false; animation.play(); }
        } catch (_) {}
      }
    }
    const io = new IntersectionObserver(entries => entries.forEach(entry => sync(entry.target, entry.isIntersecting)), {rootMargin:'160px 0px'});
    function scan(element) {
      if (!element.isConnected || element.closest('#je-review-glass')) return; // Reviews own their motion lifecycle.
      for (const animation of element.getAnimations({subtree:true})) {
        const target = animation.effect?.target;
        if (!(target instanceof Element) || target.closest('#je-review-glass') || animation.effect.getTiming().iterations !== Infinity) continue;
        let list = seen.get(target);
        if (!list) { list = []; seen.set(target, list); tracked.add(target); io.observe(target); }
        if (!list.includes(animation)) list.push(animation);
      }
    }
    function flush() {
      timer = 0;
      if (pointers.size || performance.now() < busyUntil) { schedule(); return; }
      const first = pending.values().next().value;
      if (first) { pending.delete(first); try { scan(first); } catch (_) {} }
      if (pending.size) schedule();
    }
    function schedule() {
      if (timer) return;
      timer = setTimeout(() => {
        if ('requestIdleCallback' in window) requestIdleCallback(flush, {timeout:1200});
        else flush();
      }, 180);
    }
    function queue(element) {
      if (!(element instanceof Element) || element.closest('#je-review-glass') || /^(SCRIPT|STYLE|LINK)$/.test(element.tagName)) return;
      for (const ancestor of pending) if (ancestor.contains(element)) return;
      for (const child of pending) if (element.contains(child)) pending.delete(child);
      pending.add(element); schedule();
    }
    new MutationObserver(records => {
      // Text fitting and counters must never trigger a whole-document animation scan.
      for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) queue(node);
      for (const target of tracked) if (!target.isConnected) { io.unobserve(target); tracked.delete(target); seen.delete(target); }
    }).observe(document.body, {childList:true,subtree:true});
    document.addEventListener('animationstart', event => queue(event.target), {passive:true});
    document.addEventListener('pointerdown', event => pointers.add(event.pointerId), {passive:true,capture:true});
    const end = event => { pointers.delete(event.pointerId); busyUntil = performance.now() + 320; if(pending.size) schedule(); };
    document.addEventListener('pointerup', end, {passive:true,capture:true});
    document.addEventListener('pointercancel', end, {passive:true,capture:true});
    window.addEventListener('scroll', () => { busyUntil = performance.now() + 150; }, {passive:true});
    window.addEventListener('blur', () => { pointers.clear(); });
    document.addEventListener('visibilitychange', () => {
      pointers.clear();
      if (document.hidden) tracked.forEach(target => sync(target, false));
      else tracked.forEach(target => { io.unobserve(target); io.observe(target); });
    });
    reduced.addEventListener('change', () => tracked.forEach(target => { io.unobserve(target); io.observe(target); }));
    // je-pdp-anim-heartbeat-20261008: the event-driven queue above (animationstart + mutations ->
    // idle flush, one scan per pass) can stall permanently - the timer is cleared
    // before the scan runs, so one exception in a scan kills every later scan and
    // every section the engine builds after that stays unobserved (measured on the
    // tour PDP, 2026-10-08: 11 infinite animations running off-screen, 9 of them
    // je-g-morph glass morphs; a simulated scan(document.body) finds all 26). A
    // full-body scan is one native getAnimations call plus per-animation
    // bookkeeping, so a 5 s cadence is negligible and any element the wave missed
    // is re-observed and paused within 5 s. Same gates as flush: skipped while the
    // page is hidden, a pointer is down, or scroll is settling.
    setInterval(() => {
      if (document.hidden || pointers.size || performance.now() < busyUntil) return;
      try { scan(document.body); } catch (_) {}
    }, 5000);
    queue(document.body);
  }
  function init() { categories(); animationScheduler(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => categories(event.target));
})();
